import { Tag } from "@stenajs-webui/elements";

interface ProcedureTagProps {
  label: string;
}

export function ProcedureTag({ label }: ProcedureTagProps) {
  return <Tag size={"small"} variant={"warning"} label={label} />;
}
